// ==========================================================================
// Onboarding benefit visibility — per-FSP filtering
//
// Each FSP can hide individual onboarding benefits via flags on
// `fsp.benefits` (returned by the Engine). Missing/null flags mean
// "show by default" — only an explicit `false` hides a benefit.
//
// New flags can be added per-FSP without any FE deploy:
//   1. Add an entry to FLAG_FOR_BENEFIT below
//   2. Set the flag on the FSP profile in the Engine
// ==========================================================================

import type { FSPBenefits } from '@/types/user';

export type BenefitKey = 'forecast' | 'alerts' | 'protection' | 'loans';

// Maps a benefit key to the optional flag on FSP.benefits that gates it.
// A benefit with no entry here is always visible.
const FLAG_FOR_BENEFIT: Partial<Record<BenefitKey, keyof FSPBenefits>> = {
  loans: 'loans_enabled',
  // protection: 'incentives_enabled', // future work — see ticket
};

export interface BenefitOption {
  key: BenefitKey;
  label: string;
}

export function filterBenefitsForFsp(
  options: BenefitOption[],
  benefits: FSPBenefits | null | undefined,
): BenefitOption[] {
  return options.filter((option) => {
    const flag = FLAG_FOR_BENEFIT[option.key];
    if (!flag) return true;
    // Opt-out: hide only when the flag is explicitly false.
    return benefits?.[flag] !== false;
  });
}
